// removed by extract-text-webpack-plugin
module.exports = {"text":"ContactPcs_styles__text__f0a5c4f1","info":"ContactPcs_styles__info__f0a5c4f1","contact":"ContactPcs_styles__contact__f0a5c4f1","icon":"ContactPcs_styles__icon__f0a5c4f1","label":"ContactPcs_styles__label__f0a5c4f1","phoneNumber":"ContactPcs_styles__phoneNumber__f0a5c4f1","email":"ContactPcs_styles__email__f0a5c4f1"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Pcs/ContactPcs_styles.scss
// module id = 3456
// module chunks = 4